import { Inject, Injectable, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Row } from '@vendasta/galaxy/table';
import { StartManualAutomationDialogComponent } from '@galaxy/automata/shared';
import { EntityType } from '@vendasta/automata';
import { AccessService, CRM_ACCESS_SERVICE_TOKEN } from '../../../../static/src';
import { firstValueFrom, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AutomationActionsService {
  constructor(
    private readonly dialog: MatDialog,
    @Optional() @Inject(CRM_ACCESS_SERVICE_TOKEN) private readonly accessService: AccessService,
  ) {}

  async openStartManualAutomationDialog(namespace: string, objectType: string, rows: Row[]): Promise<void> {
    const canModifyAutomations = this.accessService?.canModifyAutomations$
      ? firstValueFrom(this.accessService.canModifyAutomations$)
      : of(false);
    const hasAccess = await canModifyAutomations;
    let entityType = EntityType.ENTITY_TYPE_COMPANY;
    if (objectType === 'Contact') {
      entityType = EntityType.ENTITY_TYPE_CONTACT;
    }
    const entityMap: Map<EntityType, string[]> = new Map();
    entityMap.set(
      entityType,
      rows.map((row) => row.id),
    );
    const data = {
      partnerId: namespace,
      entities: entityMap,
      options: {
        hideSettingsLink: !hasAccess,
      },
    };
    this.dialog.open(StartManualAutomationDialogComponent, {
      data: data,
      width: '500px',
    });
  }
}
